import { render, staticRenderFns } from "./ManagementResources.vue?vue&type=template&id=3f4d5432&"
import script from "./ManagementResources.vue?vue&type=script&lang=js&"
export * from "./ManagementResources.vue?vue&type=script&lang=js&"
import style0 from "./ManagementResources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports